module.exports = __webpack_public_path__ + "img/bg1.749118b0.png";